// 対象特集タグコード（ISSUE #356対応）
export const TARGET_FEATURE_TAGS: readonly string[] = ['otakukonkatsu', 'foties-konkatsu', 'thirties-konkatsu', 'twenties-konkatsu', 'gocon'] as const

/**
 * 指定されたタグスラッグが対象特集タグかどうかをチェック
 * @param slug - チェックするタグスラッグ
 * @returns 対象特集タグの場合true
 */
export const isTargetFeatureTag = (slug: string): boolean => {
  return TARGET_FEATURE_TAGS.includes(slug)
}
